import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/payment-method";

export const savePaymentIsUsing = (PaymentIsUsing) =>
  axios.post(API_PATH + "/update-is-using", PaymentIsUsing);

export const pagingPatientpayment = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getObjById = (medicalEquipmentId) => axios.get(API_PATH + "/get-by-id/" + medicalEquipmentId);

export const saveOrUpdateObj = medicalEquipment => axios.post(API_PATH + "/save", medicalEquipment);

export const deleteObj = medicalEquipmentId => axios.delete(API_PATH + '/mark-delete/' + medicalEquipmentId);

